// services/customerService.js
import api from "./api";

export const toggleCustomerStatus = async (customerId) => {
  const response = await api.put(`/customers/toggle-status/${customerId}`);
  return response.data;
};

export const quickImportCustomers = async (customers) => {
  const response = await api.post("/customers/quick-import", { customers });
  return response.data;
};

export const quickImportToGroup = async (groupId, customers) => {
  const response = await api.post(`/group-members/quick-import/${groupId}`, { customers });
  return response.data;
};
